import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import moment from 'moment';

export const JOURNAL_TAG = {
  LIST: 'JuratJournalList'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [JOURNAL_TAG.LIST]
});

export const journalApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    getJournalEntries: build.query({
      async queryFn(args) {
        const {
          skip = 0,
          pageSize = 10,
          terms = '',
          selectedCommissionProfile = '',
          filterMonthBegin = null,
          filterMonthEnd = null,
          searchCreatedBefore = null,
          searchPaging = null
        } = args || {};

        const trimmedTerms = (terms || '').trim();
        const hasSearch = trimmedTerms.length > 0;

        try {
          if (hasSearch) {
            // Page cursor wins, then the caller's frozen search window, then a
            // fallback so the required CreatedBefore is never omitted.
            const createdBefore =
              searchPaging ||
              searchCreatedBefore ||
              (filterMonthEnd
                ? moment(filterMonthEnd, 'MM/DD/YYYY')
                    .endOf('day')
                    .utc()
                    .format()
                : moment().utc().format());

            const res = await api.Search.searchPaging(
              createdBefore,
              [trimmedTerms],
              selectedCommissionProfile || ''
            );

            const items = res?.Signings || [];
            return {
              data: {
                items,
                totalRecords:
                  res?.TotalRecords ?? res?.TotalResults ?? items.length,
                endOfResults: !!res?.EndOfResults,
                nextSearchPaging: res?.NextCreatedBefore ?? null,
                mode: 'search'
              }
            };
          }

          const filters = {};
          if (selectedCommissionProfile) {
            filters.UserProfileGUID = selectedCommissionProfile;
          }

          const body = {
            MaxResults: pageSize,
            Skip: skip,
            IncludeSubordinates: true,
            IncludeData: false,
            Filters: filters,
            OrderBy: 'SigningTimestamp',
            OrderDirection: 'desc'
          };

          if (filterMonthBegin) {
            body.CreatedAfterUtc = moment(filterMonthBegin, 'MM/DD/YYYY')
              .startOf('day')
              .utc()
              .toISOString();
          }
          if (filterMonthEnd) {
            body.CreatedBeforeUtc = moment(filterMonthEnd, 'MM/DD/YYYY')
              .endOf('day')
              .utc()
              .toISOString();
          }

          const res = await api.Enumeration('signing', body);
          const items = res?.Objects || [];
          return {
            data: {
              items,
              totalRecords: res?.TotalRecords ?? 0,
              endOfResults: !!res?.EndOfResults,
              nextSearchPaging: null,
              mode: 'enumerate'
            }
          };
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: JOURNAL_TAG.LIST, id: 'LIST' }]
    })
  })
});

export const { useGetJournalEntriesQuery } = journalApi;
